module.exports = __webpack_public_path__ + "img/donut.2be7d0fe.svg";